import { IcommonStateAction } from '../actions/commonStateAction';
import { INITIAL_COMMON_STATE, ICommonState } from '../states/renditionStates';
import * as deviceInfoService from '../utils/general/deviceInfoService';

const commonStateReducer = (state: ICommonState = INITIAL_COMMON_STATE, action: IcommonStateAction) => {
    switch (action.type) {
        case 'GET_SCREEN_TYPE':
            const _screenType = deviceInfoService.screenType();
            // Changing the imageSizeCategory of the image model
            let _imageSizeCategory: string = "default";
            if (_screenType == "extraLargeScreen") {
                _imageSizeCategory = "default";
            } else if (_screenType == 'largeScreen') {
                _imageSizeCategory = "default";
            } else if (_screenType == 'mediumScreen') {
                _imageSizeCategory = "medium";
            } else if (_screenType == 'smallScreen') {
                _imageSizeCategory = "small";
            } else if (_screenType == 'extraSmallScreen') {
                _imageSizeCategory = "small";
            }
            return { ...state, screenType: _screenType, imageSizeCategory: _imageSizeCategory };
        case 'GET_MENU_CODE':
            const _menuCode = window.sessionStorage.getItem('cv_menuCode');
            return { ...state, menuCode: _menuCode };    
        case 'CHANGE_COMPANY_METADATA':
            // Improtant!!! when you use multiCompanyMetaData, you must check shouldComponentUpdate, example see ratingBlockGroupTemplate!
            let _multiCompanyMetaData = null;
            _multiCompanyMetaData = action.value;
            return { ...state, multiCompanyMetaData: _multiCompanyMetaData };
        case 'CHANGE_SWITCH_PAGE_DATA':
            // Improtant!!!
            let _switchPageData = null;
            _switchPageData = action.value;
            return { ...state, switchPageData: _switchPageData };
        case 'SHOW_RIGHT_PANE_STATE':
            return { ...state, collapsed: action.value };
        case 'MENU_PANE_STATUS_DATA':
            return { ...state, menuPaneStatus: action.value };
        case 'OFF_THE_CUFF_TITLE':
            return { ...state, offTheCuffTitle: action.value };
        case 'CURRENT_AUTHOR_ID':
            return { ...state, currentAuthorID: action.value };
        case 'CURRENT_AUTHOR_NAME':
            return { ...state, currentAuthorName: action.value };
        case 'UPDATE_HEALTH_WARNING_WIDTH':
            return { ...state, updateHealthWarningWidth: action.value };
        case 'HTML_PDF_TOGGLE_STATUS':
            return { ...state, htmlPDFtoggleStatus: action.value };
        case 'FRONT_PAGE_LOADED':
            return { ...state, frontpageloaded: action.value };
        case 'UPDATE_FINANCIALS_CONTENT_TAB_TITLE':
            return { ...state, updateFinancialsContentTabTitle: action.value };
        case 'FETCH_BODY_JSON_FINISHED':
            return { ...state, fetchBodyJsonFinished: action.value };
        case 'COMPANY_COVERAGE_AND_DERIVED_FIELDS':
            return { ...state, companyCoverageAndDerivedFields: action.value };
        default:
            return state;
    }
};

export default commonStateReducer;
